import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { MatSnackBar } from "@angular/material";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { UserService } from "../Services/user.service";
import { CheckListDTO, ImageDTO, ProceduresDTO, StepDTO } from './userProfileDTO.model';

declare var $: any;
declare var swal: any;
@Component({
  selector: 'app-company-user',
  templateUrl: './company-user.component.html',
  styleUrls: ['./company-user.component.scss'],
  providers: [UserService]
})

export class CompanyUserComponent implements OnInit {
  codeValue: string;
  descriptionValue: string;
  iValue: number;
  showEditingDiv: number;
  step: string;
  //showDetails;
  universalHideAndShowMpId;
  isMobile;
  deviceOfflineColm: boolean;
  index: boolean;
  edit: boolean;

  userId: number;

  selectedRoles: Array<string>;
  public loading = false;
  showAlreadyExist: boolean;

  specialities: any[];
  procedure: ProceduresDTO;
  procedures: any;
  Images: ImageDTO[];
  Steps: StepDTO[];
  orCheckList: CheckListDTO;
  ppCheckList: CheckListDTO;
  noteCheckList: CheckListDTO;
  etcCheckList: CheckListDTO;
  httpClient: any;
  addImageInvisible: number;
  addChecklistItem: number;
  selectedProcedureId: any;
  category: number;
  createProcedure: number;

  constructor(private http: Http, private spinnerService: Ng4LoadingSpinnerService, private cookieService: CookieService, private userService: UserService, private router: Router, private appUser: AppWideUser, private token: Token, private snackBar: MatSnackBar) {
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.iValue = -1;
    this.showEditingDiv = -1;
    this.addImageInvisible = 0;
    this.addChecklistItem = 0;


    this.universalHideAndShowMpId = 0;
    this.deviceOfflineColm = true;

    this.index = true;

  }

  cancelAddProc() {
    this.createProcedure = 0;
  }
  UserClick(btnCount) {
    
    this.index = false;
    this.edit = false;
    if (btnCount == 0) {
      this.createProcedure = 1;
      this.index = true;
      this.edit = false;
    }
    if (btnCount == 1) {
      this.index = true;
      this.edit = false;
      this.selectedProcedureId = 0;
      this.category = 0;
    }
    if (btnCount == 2) {
      this.edit = true;
      this.index = false;
    }
    if (btnCount == 3) {
      this.edit = true;
      this.addImageInvisible = 1;
    }

  }

  ngOnInit() {
    this.getSpecialities();
    this.getProcedures();

  }

  getProcedures(): any {

    this.orCheckList = new CheckListDTO;
    this.orCheckList.Images = [];
    this.orCheckList.Steps = [];

    this.ppCheckList = new CheckListDTO;
    this.ppCheckList.Images = [];
    this.ppCheckList.Steps = [];

    this.noteCheckList = new CheckListDTO;
    this.noteCheckList.Images = [];
    this.noteCheckList.Steps = [];

    this.etcCheckList = new CheckListDTO;
    this.etcCheckList.Images = [];
    this.etcCheckList.Steps = [];

    this.Images = [{ ImageName: "Image1", ImageUrl: "ImageUrl1" }, { ImageName: "Image2", ImageUrl: "ImageUrl2" }, { ImageName: "Image3", ImageUrl: "ImageUrl3" }];
    this.Steps = [{ stepNo: 1, stepContent: "open ot door" }, { stepNo: 2, stepContent: "enter operation theater" }, { stepNo: 3, stepContent: "close ot door" }];

    this.procedures = new ProceduresDTO()[6];
    this.procedures = [{ SpecialityName: "Dermatology", ProcedureId: 1, ProcedureName: "procedure1", OperationRoomCheckList: this.orCheckList, PatientPositionChecklist: this.ppCheckList, NotesCheckList: this.noteCheckList, PreperationChecklist: this.etcCheckList },
    { SpecialityName: "Dermatology", ProcedureId: 2, ProcedureName: "procedure2", OperationRoomCheckList: this.orCheckList, PatientPositionChecklist: this.ppCheckList, NotesCheckList: this.noteCheckList, PreperationChecklist: this.etcCheckList },
    { SpecialityName: "Nephrology", ProcedureId: 3, ProcedureName: "procedure1", OperationRoomCheckList: this.orCheckList, PatientPositionChecklist: this.ppCheckList, NotesCheckList: this.noteCheckList, PreperationChecklist: this.etcCheckList },
    { SpecialityName: "Nephrology", ProcedureId: 4, ProcedureName: "procedure2", OperationRoomCheckList: this.orCheckList, PatientPositionChecklist: this.ppCheckList, NotesCheckList: this.noteCheckList, PreperationChecklist: this.etcCheckList },
    { SpecialityName: "Nephrology", ProcedureId: 5, ProcedureName: "procedure3", OperationRoomCheckList: this.orCheckList, PatientPositionChecklist: this.ppCheckList, NotesCheckList: this.noteCheckList, PreperationChecklist: this.etcCheckList },
    { SpecialityName: "Gynecology", ProcedureId: 6, ProcedureName: "procedure1", OperationRoomCheckList: this.orCheckList, PatientPositionChecklist: this.ppCheckList, NotesCheckList: this.noteCheckList, PreperationChecklist: this.etcCheckList }];
  }
  getSpecialities(): any {
    this.specialities = ["Dermatology", "Nephrology", "Neurology", "Neurosurgery", "Gynecology", "Pathology"];
  }
  newChecklistItem() {
    this.addChecklistItem = 1;
  }
  cancelAddImage() {
    this.addImageInvisible = 0;
  }
  cancelAddChecklist() {
    this.addChecklistItem = 0;
  }
  addORChecklistItem(desc) {

    this.step = desc;

  }
  getORChecklistDetails(pId) {
    this.selectedProcedureId = pId;
    this.category = 1;
  }
  getPPChecklistDetails(pId) {
    this.selectedProcedureId = pId;
    this.category = 2;
  }
  getNoteChecklistDetails(pId) {
    this.selectedProcedureId = pId;
    this.category = 3;
  }
  getEtcChecklistDetails(pId) {
    this.selectedProcedureId = pId;
    this.category = 4;
  }
  cancelEditChecklist() {
    this.showEditingDiv = -1;
  }
  DeleteChecklistItem(index: number) {
    this.Steps.splice(index, 1);
  }
  deleteImage(index: number) {
    this.Images.splice(index, 1);

  }
  editChecklistItem(index: number, desc) {
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.descriptionValue = desc;
    }
    else {
      this.descriptionValue = desc;
      this.showEditingDiv = index;
      this.iValue = index;
    }
  }
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/company-user/company-user.component.ts